module.exports = __webpack_public_path__ + "static/media/report-to-generate.847b1e85.png";